__turbopack_context__.v({
  "name": "index-module-scss-module__Mqj7nq__name",
});
